import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <main data-testid="blog-page" className="pt-32 pb-28">
      <Seo title="Blog — Bahare | Photography, Real Estate & Education"
        description="Notes on photography, light, sessions and life in Los Angeles — by Bahare, photographer, realtor and educator." />
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#7A7A7A] mb-4">Journal</p>
          <h1 className="font-serif text-5xl md:text-6xl font-light tracking-tight mb-16">Notes & <span className="italic">stories.</span></h1>
        </Reveal>
        <div className="grid sm:grid-cols-2 gap-10 md:gap-14">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 0.1}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block">
                {p.cover_image && (
                  <div className="overflow-hidden mb-6 bg-[#EFEFEC]">
                    <img src={imgUrl(p.cover_image)} alt={p.title} loading="lazy"
                      className="w-full aspect-[4/3] object-cover group-hover:scale-[1.03] transition-transform duration-[1200ms] ease-out" />
                  </div>
                )}
                <p className="text-[11px] uppercase tracking-[0.2em] text-[#7A7A7A] mb-2">
                  {new Date(p.created_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                </p>
                <h2 className="font-serif text-2xl md:text-3xl font-light leading-snug mb-3 group-hover:italic transition-all">{p.title}</h2>
                {p.excerpt && <p className="text-sm text-[#4A4A4A] leading-relaxed">{p.excerpt}</p>}
              </Link>
            </Reveal>
          ))}
        </div>
        {posts.length === 0 && <p className="text-sm text-[#7A7A7A]">Stories are on their way.</p>}
      </div>
    </main>
  );
}
